import React, { createContext, useContext, useState } from "react";

export interface QueryParams {
  // 任务ID
  taskId?: string;
  // 任务编码
  subjectCode?: string;
  // 上传人
  createUser?: string;
  // 审核时间
  startTime?: string;
  endTime?: string;
  // 完成状态
  account?: string;
  // 审核状态
  auditState?: string;
  // 预警状态
  warningState?: string;
  // 租户编码
  tenantCode?: string;
  // 项目中心
  projectList?: string[];
  // 所属中心
  centerCode?: string;
}

export type QueryParamsType = keyof QueryParams;

interface Ctx {
  showMore: boolean;
  handleToggle: () => void;
  queryParams: QueryParams;
  setQueryParams: (params: QueryParams) => void;
  updateQueryParams: (params: QueryParams) => void;
}

const ContextNew = createContext<Ctx>({
  showMore: false,
  handleToggle: () => {},
  queryParams: {},
  setQueryParams: () => {},
  updateQueryParams: () => {},
});

interface ProviderProps {
  children: React.ReactNode;
}
export default function Provider({ children }: ProviderProps) {

  const [queryParams, setQueryParams] = useState<QueryParams>({});
  
  const [showMore, setShowMore] = useState<boolean>(false);
  
  const updateQueryParams = (params: QueryParams) => {
    setQueryParams({ ...queryParams, ...params });
  };

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  return (
    <ContextNew.Provider
      value={{
        showMore,
        handleToggle,
        queryParams,
        setQueryParams,
        updateQueryParams,
      }}
    >
      {children}
    </ContextNew.Provider>
  );
}

export const useAccoutContext = () => useContext(ContextNew);
